/** @format */

import Cookies from 'js-cookie';
import { Storage } from '@power/utils';
import { ACCESS_TOKEN_KEY } from '@/enums/cacheEnum';

const ExpiresInKey = 'Admin-Expires-In';

export function getToken() {
	return Storage.get(ACCESS_TOKEN_KEY);
}

export function setToken(token) {
	return Cookies.set(ACCESS_TOKEN_KEY, token);
}

export function removeToken() {
	return Cookies.remove(ACCESS_TOKEN_KEY);
}

export function getExpiresIn() {
	return Cookies.get(ExpiresInKey) || -1;
}

export function setExpiresIn(time) {
	return Cookies.set(ExpiresInKey, time);
}

export function removeExpiresIn() {
	return Cookies.remove(ExpiresInKey);
}

export function setUserAccount(userAccount) {
	return Storage.set('userAccount', userAccount);
}

export function getUserAccount() {
	return Storage.get('userAccount');
}

export function onLogout() {
	localStorage.clear();
	sessionStorage.clear();
	return true;
}
